export enum PlanType {
    FREE = "FREE",
    BASIC = "BASIC",
    PRO = "PRO",
    ELITE = "ELITE"
}
